
import { UseFormRegister } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import type { Application } from '@/types/database.types';

interface BasicCompanyInfoProps {
  register: UseFormRegister<Partial<Application>>;
}

export const BasicCompanyInfo = ({ register }: BasicCompanyInfoProps) => {
  return (
    <div className="space-y-4">
      <h4 className="text-sm font-medium text-muted-foreground">Company Identity</h4>

      {/* Legal Name and DBA in a grid layout */}
      <div className="grid gap-4 md:grid-cols-2">
        <div className="space-y-2">
          <Label htmlFor="company_legal_name">Legal Name</Label>
          <Input 
            id="company_legal_name" 
            {...register('company_legal_name')} 
            placeholder="Enter legal company name"
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="company_dba">DBA (if applicable)</Label>
          <Input 
            id="company_dba" 
            {...register('company_dba')} 
            placeholder="Doing Business As"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="company_website">Website</Label>
        <Input 
          id="company_website" 
          {...register('company_website')} 
          placeholder="https://www.example.com"
        />
      </div>
    </div>
  );
};
